import { DraftTopExpression } from 'bones/utils/queryBuilder/types';

export const sliceTopExpression = ({
  topExpression,
  subExpressionIdx,
  expressionIdx,
  filterIdx,
}: {
  topExpression: DraftTopExpression;
  subExpressionIdx: number;
  expressionIdx: number;
  filterIdx: number;
}): DraftTopExpression => {
  const subExpression = topExpression.expressions[subExpressionIdx];
  const expression = subExpression.expressions[expressionIdx];
  return {
    ...topExpression,
    expressions: [
      ...topExpression.expressions.slice(0, subExpressionIdx),
      {
        ...subExpression,
        expressions: [
          ...subExpression.expressions.slice(0, expressionIdx),
          {
            ...expression,
            filters: [...expression.filters.slice(0, filterIdx)],
          },
        ],
      },
    ],
  };
};
